import { render, staticRenderFns } from "./BtnPicker.vue?vue&type=template&id=4627c1aa&scoped=true&"
import script from "./BtnPicker.vue?vue&type=script&lang=js&"
export * from "./BtnPicker.vue?vue&type=script&lang=js&"
import style0 from "./BtnPicker.vue?vue&type=style&index=0&id=4627c1aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4627c1aa",
  null
  
)

export default component.exports